// extracted by mini-css-extract-plugin
export default {"win-item":"winning-information_win-item__2h1Nw"};